import somaLinks from './somaLinks';

export default somaLinks;
